import React from "react";

export const ClusterMarker = ({points}) => {
    const SIZE = 48;
    return (
        <div style={{
            width: SIZE,
            height: SIZE,
            background: "green",
            color: "white",
            borderRadius: SIZE / 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }}>
            {points.length}
        </div>
    );
};

export default ClusterMarker;